import enumValueGetter from './enumFormatter';

const bidStrategyValueGetter = (value, dataRow, params, ...rest) => {
    const { valueGetter } = params;
    const bidStrategyValue = valueGetter(dataRow);
    return enumValueGetter(bidStrategyValue, dataRow, params, ...rest);
};

export default bidStrategyValueGetter;
